import PropTypes from 'prop-types';

export const Brand = PropTypes.shape({
  brand_id: PropTypes.number,
  uri: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string.isRequired,
  logo_version: PropTypes.number,
  image_url: PropTypes.string.isRequired,
});

export const BrandMapPropType = PropTypes.objectOf(
  PropTypes.shape({
    [PropTypes.number]: Brand,
  }),
);

export default Brand;
